import { useFormik } from "formik";
import Select from "../../../components/select";
import { useMemberList, usePoolList, useSubnetList } from "../layout/resuableEffect";
import * as Yup from "yup";
import Input from "../../../components/input";
import arrow from "../../../assets/svg-icons/blueArrow.svg";
import { useDispatch, useSelector } from "react-redux";
import { createNetworkSubnet, listLoadBalancer, deletePoolMember, createLoadBalancer, createLoadListener, updateLoadListener, listLoadPool, createPoolMember, updatePoolMember } from "../../../hooks/local/userReducer";
import { useNavigate } from "react-router-dom";
import { useState, useMemo } from "react";
import { FormatDate } from "../../../hooks/constants";
import close from "../../../assets/svg-icons/closeBrand.svg";
import Modal from "../../../components/modal";
import TabContent from "../../../components/TabContent";
import Button from "../../../components/button";
import LoadBalancerInstances from "./loadBalancerInstances";

const LoadBalancerMembers = () => {
  document.title = "Load Balancer Members - Cloudvantage";

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedProject = useSelector((state) => state.user.selectedProject);
  const currency = useSelector((state) => state.user.currency);
  const selectedPool = JSON.parse(sessionStorage.getItem("selectedPool"));

  const [loadPool, setLoadPool] = useState(null);
  const [isFetched, setIsFetched] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [manageHealthMonitorModal, setManageHealthMonitorModal] = useState(false);
  const [createMemberModal, setCreateMemberModal] = useState(false);
  const [editMemberModal, setEditMemberModal] = useState(false);
  const [deleteMemberModal, setDeleteMemberModal] = useState(false);
  const [healthMonitorDetailsModal, setHealthMonitorDetailsModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  const projectId = selectedProject?.id;

  const toggleCreateMemberModal = () => {
    setCreateMemberModal(!createMemberModal);
  };

  const createMemberForm = useFormik({
    initialValues: {
      members: [
        {
          name: "",
          protocol_port: "",
          ipAddress: "",
          weight: "1",
          backup: false,
          monitor_address: "",
          monitor_port: "",
        },
      ],
    },
    validationSchema: Yup.object({
      members: Yup.array().of(
        Yup.object({
          name: Yup.string().required("Name is required"),
          ipAddress: Yup.string()
            .matches(
              /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/,
              "Invalid IP address format"
            )
            .required("IP Address is required"),
          protocol_port: Yup.number()
            .required("Protocol Port is required")
            .min(1, "Port must be between 1 and 65535")
            .max(65535, "Port must be between 1 and 65535"),
          weight: Yup.number()
            .required("Weight is required")
            .min(1, "Weight must be between 1 and 256")
            .max(256, "Weight must be between 1 and 256"),
          // backup: Yup.boolean().notRequired(),
          // monitor_address: Yup.string()
          //   .matches(
          //     /^(?:(?:[0-9]{1,3}\.){3}[0-9]{1,3}|)$/,
          //     "Invalid IP address format"
          //   )
          //   .notRequired(),
          // monitor_port: Yup.number()
          //   .min(1, "Port must be between 1 and 65535")
          //   .max(65535, "Port must be between 1 and 65535")
          //   .notRequired(),
        })
      ),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {

        let createPoolMemberFormData;

        

        if(values.members.length > 1) {
          createPoolMemberFormData = values.members.map(member => ({
            name: member.name,
            protocol_port: Number(member.protocol_port),
            address: member.ipAddress,
            pool_id: selectedPool?.poolId,
            weight: Number(member.weight),
            // backup: member.backup ?? undefined,
            // monitor_address: member.monitor_address ?? undefined,
            // monitor_port: member.monitor_port ? Number(member.monitor_port) : undefined,
          }));
        } else {
            createPoolMemberFormData = {
              name: values?.members[0]?.name,
              protocol_port: Number(values?.members[0].protocol_port),
              address: values?.members[0].ipAddress,
              pool_id: selectedPool?.poolId,
              weight: Number(values?.members[0].weight),
              // backup: values?.members[0].backup ?? undefined,
              // monitor_address: values?.members[0].monitor_address ?? null,
              // monitor_port: values?.members[0].monitor_port ? Number(values?.members[0].monitor_port) : undefined,
            }
        }

        const { payload } = await dispatch(createPoolMember({
          ...createPoolMemberFormData,
          projectId: selectedProject?.id,
        }));

        if (payload.statuscode === "00") {
          window.location.reload();
        } else {
          throw new Error(`Failed to create members: Status code ${payload.statuscode}`);
        }
      } catch (error) {
        console.error("Error creating pool members:", error);
      }
    },
  });

  const addMember = () => {
    const newMembers = [
      ...createMemberForm.values.members,
      {
        name: "",
        protocol_port: "",
        ipAddress: "",
        weight: "1",
        backup: false,
        monitor_address: "",
        monitor_port: "",
      },
    ];
    createMemberForm.setFieldValue("members", newMembers);
  };

  const removeMember = (index) => {
    const newMembers = createMemberForm.values.members.filter((_, i) => i !== index);
    createMemberForm.setFieldValue("members", newMembers);
  };

  const createMemberInputs = useMemo(
    () =>
      createMemberForm.values.members.map((member, index) => ({
        title: `Member ${index + 1}`,
        inputs: [
          {
            type: "text",
            element: "input",
            name: `members[${index}].name`,
            label: "Name *",
            placeholder: "e.g., Member 1",
            value: member.name,
            colSpan: 1,
            onChange: createMemberForm.handleChange,
            onBlur: createMemberForm.handleBlur,
            onError:
              createMemberForm.touched.members?.[index]?.name &&
              createMemberForm.errors.members?.[index]?.name
                ? createMemberForm.errors.members[index].name
                : null,
          },
          {
            type: "text",
            element: "input",
            name: `members[${index}].ipAddress`,
            label: "IP Address *",
            placeholder: "e.g., 192.0.2.51",
            value: member.ipAddress,
            colSpan: 1,
            onChange: createMemberForm.handleChange,
            onBlur: createMemberForm.handleBlur,
            onError:
              createMemberForm.touched.members?.[index]?.ipAddress &&
              createMemberForm.errors.members?.[index]?.ipAddress
                ? createMemberForm.errors.members[index].ipAddress
                : null,
          },
          {
            type: "number",
            element: "input",
            name: `members[${index}].protocol_port`,
            label: "Port *",
            placeholder: "e.g., 80",
            value: member.protocol_port,
            colSpan: 1,
            onChange: createMemberForm.handleChange,
            onBlur: createMemberForm.handleBlur,
            onError:
              createMemberForm.touched.members?.[index]?.protocol_port &&
              createMemberForm.errors.members?.[index]?.protocol_port
                ? createMemberForm.errors.members[index].protocol_port
                : null,
          },
          {
            type: "number",
            element: "input",
            name: `members[${index}].weight`,
            label: "Weight *",
            placeholder: "1",
            value: member.weight,
            colSpan: 1,
            onChange: createMemberForm.handleChange,
            onBlur: createMemberForm.handleBlur,
            onError:
              createMemberForm.touched.members?.[index]?.weight &&
              createMemberForm.errors.members?.[index]?.weight
                ? createMemberForm.errors.members[index].weight
                : null,
          },
          // {
          //   type: "choice",
          //   element: "choice",
          //   name: `members[${index}].backup`,
          //   label: "Backup",
          //   choices: [
          //     { label: "Yes", value: true },
          //     { label: "No", value: false },
          //   ],
          //   value: member.backup,
          //   colSpan: 1,
          //   onChange: (value) =>
          //     createMemberForm.setFieldValue(`members[${index}].backup`, value),
          //   onBlur: createMemberForm.handleBlur,
          //   onError:
          //     createMemberForm.touched.members?.[index]?.backup &&
          //     createMemberForm.errors.members?.[index]?.backup
          //       ? createMemberForm.errors.members[index].backup
          //       : null,
          // },
          // {
          //   type: "text",
          //   element: "input",
          //   name: `members[${index}].monitor_address`,
          //   label: "Monitor Address",
          //   placeholder: "Optional monitor IP",
          //   value: member.monitor_address,
          //   colSpan: 1,
          //   onChange: createMemberForm.handleChange,
          //   onBlur: createMemberForm.handleBlur,
          //   onError:
          //     createMemberForm.touched.members?.[index]?.monitor_address &&
          //     createMemberForm.errors.members?.[index]?.monitor_address
          //       ? createMemberForm.errors.members[index].monitor_address
          //       : null,
          // },
          // {
          //   type: "number",
          //   element: "input",
          //   name: `members[${index}].monitor_port`,
          //   label: "Monitor Port",
          //   placeholder: "Optional monitor port",
          //   value: member.monitor_port,
          //   colSpan: 1,
          //   onChange: createMemberForm.handleChange,
          //   onBlur: createMemberForm.handleBlur,
          //   onError:
          //     createMemberForm.touched.members?.[index]?.monitor_port &&
          //     createMemberForm.errors.members?.[index]?.monitor_port
          //       ? createMemberForm.errors.members[index].monitor_port
          //       : null,
          // },
        ],
      })),
    [
      createMemberForm.values.members,
      createMemberForm.touched.members,
      createMemberForm.errors.members,
      createMemberForm.handleChange,
      createMemberForm.handleBlur,
    ]
  );

  

//   {
//     "id": "e67fb728-bbd4-46d0-9139-7ebcf1805a19",
//     "name": "mem1",
//     "protocol": "N/A",
//     "ipAddress": "173.231.227.58",
//     "port": 80,
//     "pool": "N/A",
//     "weight": 1,
//     "backup": "No",
//     "operatingStatus": "ONLINE",
//     "provisioningStatus": "ACTIVE",
//     "adminState": "Yes",
//     "createdAt": "2025-06-30 07:44:27"
// }

  const editMemberForm = useFormik({
    initialValues: {
      name: selectedMember?.name || "",
      protocol_port: selectedMember?.port || "",
      ipAddress: selectedMember?.ipAddress || "",
      weight: selectedMember?.weight || "1",
      backup: selectedMember?.memberDetails?.backup || false,
      monitor_address: selectedMember?.memberDetails?.monitor_address || "",
      monitor_port: selectedMember?.memberDetails?.monitor_port || "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      name: Yup.string().optional(),
      ipAddress: Yup.string()
        .matches(
          /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/,
          "Invalid IP address format"
        )
        .required("IP Address is required"),
      protocol_port: Yup.number()
        .required("Protocol Port is required")
        .min(1, "Port must be between 1 and 65535")
        .max(65535, "Port must be between 1 and 65535"),
      weight: Yup.number()
        .required("Weight is required")
        .min(1, "Weight must be between 1 and 256")
        .max(256, "Weight must be between 1 and 256"),
      backup: Yup.boolean().notRequired(),
      monitor_address: Yup.string()
        .matches(
          /^(?:(?:[0-9]{1,3}\.){3}[0-9]{1,3}|)$/,
          "Invalid IP address format"
        )
        .notRequired(),
      monitor_port: Yup.number()
        .min(1, "Port must be between 1 and 65535")
        .max(65535, "Port must be between 1 and 65535")
        .notRequired(),
    }),
    onSubmit: async (values, { resetForm }) => {
      const editMemberFormData = {
        projectId,
        memberId: selectedMember?.id,
        poolId: selectedPool?.poolId,
        name: values.name,
        protocol_port: parseInt(values.protocol_port),
        address: values.ipAddress,
        weight: parseInt(values.weight),
        backup: values.backup || false,
        // monitor_address: values.monitor_address || undefined,
        // monitor_port: values.monitor_port ? parseInt(values.monitor_port) : undefined,
      };

      const { payload } = await dispatch(updatePoolMember(editMemberFormData));
      if (payload.statuscode === "00") {
        window.location.reload();
      }
    },
  });

  const editMemberInputs = useMemo(
    () => [
      {
        type: "text",
        element: "input",
        name: "name",
        label: "Name *",
        placeholder: "e.g., Member 1",
        value: editMemberForm.values.name,
        colSpan: 1,
        onChange: editMemberForm.handleChange,
        onBlur: editMemberForm.handleBlur,
        onError:
          editMemberForm.touched.name && editMemberForm.errors.name
            ? editMemberForm.errors.name
            : null,
      },
      {
        type: "text",
        element: "input",
        name: "ipAddress",
        label: "IP Address *",
        placeholder: "e.g., 192.0.2.51",
        value: editMemberForm.values.ipAddress,
        disabled: true,
        colSpan: 1,
        onChange: editMemberForm.handleChange,
        onBlur: editMemberForm.handleBlur,
        onError:
          editMemberForm.touched.ipAddress && editMemberForm.errors.ipAddress
            ? editMemberForm.errors.ipAddress
            : null,
      },
      {
        type: "number",
        element: "input",
        name: "protocol_port",
        label: "Port *",
        placeholder: "e.g., 80",
        value: editMemberForm.values.protocol_port,
        disabled: true,
        colSpan: 1,
        onChange: editMemberForm.handleChange,
        onBlur: editMemberForm.handleBlur,
        onError:
          editMemberForm.touched.protocol_port && editMemberForm.errors.protocol_port
            ? editMemberForm.errors.protocol_port
            : null,
      },
      {
        type: "number",
        element: "input",
        name: "weight",
        label: "Weight *",
        placeholder: "1",
        value: editMemberForm.values.weight,
        colSpan: 1,
        onChange: editMemberForm.handleChange,
        onBlur: editMemberForm.handleBlur,
        onError:
          editMemberForm.touched.weight && editMemberForm.errors.weight
            ? editMemberForm.errors.weight
            : null,
      },
      // {
      //   type: "single",
      //   element: "checkbox",
      //   name: "backup",
      //   label: "Backup",
      //   value: editMemberForm.values.backup,
      //   colSpan: 1,
      //   onChange: (e) => {
      //     editMemberForm.setFieldValue("backup", e.target.checked); 
      //   },
      //   onBlur: editMemberForm.handleBlur,
      //   onError:
      //     editMemberForm.touched.backup && editMemberForm.errors.backup
      //       ? editMemberForm.errors.backup
      //       : null,
      // },
      // {
      //   type: "text",
      //   element: "input",
      //   name: "monitor_address",
      //   label: "Monitor Address",
      //   placeholder: "Optional monitor IP",
      //   value: editMemberForm.values.monitor_address,
      //   colSpan: 1,
      //   onChange: editMemberForm.handleChange,
      //   onBlur: editMemberForm.handleBlur,
      //   onError:
      //     editMemberForm.touched.monitor_address &&
      //     editMemberForm.errors.monitor_address
      //       ? editMemberForm.errors.monitor_address
      //       : null,
      // },
      // {
      //   type: "number",
      //   element: "input",
      //   name: "monitor_port",
      //   label: "Monitor Port",
      //   placeholder: "Optional monitor port",
      //   value: editMemberForm.values.monitor_port,
      //   colSpan: 1,
      //   onChange: editMemberForm.handleChange,
      //   onBlur: editMemberForm.handleBlur,
      //   onError:
      //     editMemberForm.touched.monitor_port && editMemberForm.errors.monitor_port
      //       ? editMemberForm.errors.monitor_port
      //       : null,
      // },
    ],
    [
      editMemberForm.values,
      editMemberForm.touched,
      editMemberForm.errors,
      editMemberForm.handleChange,
      editMemberForm.handleBlur,
    ]
  );

  const overviewDetails = [
    {
      title: "Name",
      value: loadPool?.name || "N/A",
    },
    {
      title: "Listener ID",
      value: loadPool?.id || "N/A",
    },
    {
      title: "Project ID",
      value: loadPool?.project_id || "N/A",
    },
    {
      title: "Connection Limit",
      value: loadPool?.connection_limit === -1 ? "Limited" : "Unlimited" || "N/A",
    },
    {
      title: "Insert Headers",
      value:
        Object.keys(loadPool?.insert_headers || {}).length > 0
          ? JSON.stringify(loadPool.insert_headers)
          : "None",
    },
    {
      title: "Default Pool ID",
      value: loadPool?.default_pool_id || "N/A",
    },
    {
      title: "Client Data Timeout",
      value: loadPool?.timeout_client_data || "N/A",
    },
    {
      title: "Member Connect Timeout",
      value: loadPool?.timeout_member_connect || "N/A",
    },
    {
      title: "Member Data Timeout",
      value: loadPool?.timeout_member_data || "N/A",
    },
    {
      title: "TCP Inspect Timeout",
      value: loadPool?.timeout_tcp_inspect || "N/A",
    },
    {
      title: "Allowed Cidrs",
      value: loadPool?.allowed_cidrs || "N/A",
    },
    {
      title: "TLS Cipher String",
      value: loadPool?.tls_ciphers || "N/A",
    },
  ];

  const memberOverviewDetails = selectedMember
    ? [
        {
          title: "Name",
          value: selectedMember?.name || "N/A",
        },
        {
          title: "Member ID",
          value: selectedMember?.id || "N/A",
        },
        {
          title: "Project ID",
          value: selectedMember?.project_id || "N/A",
        },
        {
          title: "IP Address",
          value: selectedMember?.address || "N/A",
        },
        {
          title: "Protocol Port",
          value: selectedMember?.protocol_port || "N/A",
        },
        {
          title: "Weight",
          value: selectedMember?.weight || "N/A",
        },
        {
          title: "Backup",
          value: selectedMember?.backup ? "Yes" : "No",
        },
        {
          title: "Monitor Address",
          value: selectedMember?.monitor_address || "N/A",
        },
        {
          title: "Monitor Port",
          value: selectedMember?.monitor_port || "N/A",
        },
      ]
    : [];

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
    setCurrentPage(1);
  };

  const options = [
    { value: "all-members", label: "All members" },
    { value: "name", label: "Member Name" },
  ];

  const showManageMonitorModal = (key, data) => {
    setManageHealthMonitorModal(key);
    setSelectedMember(data);
  };

  const closeManageSubnetModal = () => {
    setManageHealthMonitorModal(false);
    setSelectedMember(null);
  };

  const toggleEditMemberModal = () => {
    setEditMemberModal(!editMemberModal);
  };

  const showMemberDetailsModal = (subnet) => {
    setSelectedMember(subnet);
    setHealthMonitorDetailsModal(true);
  };

  const closeHealthMonitorDetailsModal = () => {
    setHealthMonitorDetailsModal(false);
    setSelectedMember(null);
  };

  const memberList = useMemberList(projectId, selectedPool?.poolId);

  const memberListMap = Array.isArray(memberList)
    ? memberList.map((member) => ({
        id: member.id,
        memberDetails: member,
        name: member.name && member.name.trim() !== "" ? member.name : "Default Member",
        protocol: member?.protocol || "N/A",
        ipAddress: member?.address || "N/A",
        port: member?.protocol_port || "N/A",
        pool: member?.default_pool_id || "N/A",
        weight: member?.weight || 0,
        backup: member?.backup ? "Yes" : "No",
        operatingStatus: member?.operating_status || "N/A",
        provisioningStatus: member?.provisioning_status || "N/A",
        adminState: member?.admin_state_up ? "Yes" : "No",
        createdAt: FormatDate(member.created_at),
      }))
    : [];

  const [currentPage, setCurrentPage] = useState(1);
  const entriesPerPage = 5;

  const filteredData = memberListMap?.filter(
    (row) =>
      row?.name?.toLowerCase().includes(searchText.toLowerCase()) ||
      row?.provisioningStatus?.toLowerCase().includes(searchText.toLowerCase()) ||
      row?.type?.toLowerCase().includes(searchText.toLowerCase()) ||
      row?.operatingStatus?.toLowerCase().includes(searchText.toLowerCase())
  );

  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
  const currentEntries = filteredData.slice(indexOfFirstEntry, indexOfLastEntry);
  const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleServerAction = async (action, memberId) => {
    const projectId = selectedProject.id;
    const poolId = selectedPool?.poolId;

    const data = {
      poolId,
      memberId,
    };

    const { payload } = await dispatch(action({ projectId, data }));

      if (payload.statuscode === "00") {
        window.location.reload();
      }
  };

  const deleteLoadPoolMember = (memberId) =>
    handleServerAction(deletePoolMember, memberId);

  return (
    <div className="min-h-screen px-4 md:px-10 pt-6 pb-10 dark:text-white">
      <div>
        {memberListMap?.length > 0 ? (
          <div>
            <div className="w-full flex items-center">
              <div className="w-full grid grid-cols-1 md:grid-cols-12 gap-4 items-end my-10">
                <div className="md:col-span-3">
                  <Select label="Filter member" name="member" options={options} />
                </div>
                <div className="md:col-span-4">
                  <input
                    type="search"
                    name=""
                    value={searchText}
                    onChange={handleSearchChange}
                    placeholder="Search for member..."
                    className="bg-white text-black w-full p-4 text-sm rounded-md border border-[#c4c4c460] active:outline-0 focus:outline-0 placeholder:opacity-70 placeholder:text-xs dark:bg-slate-800 dark:text-white"
                  />
                </div>
              </div>
              <div className="w-full flex items-end justify-end">
                <button
                  className={`cursor-pointer px-4 py-3 text-xs border-[1.5px] border-primaryBlue rounded-md text-primaryBlue w-fit`}
                  onClick={toggleCreateMemberModal}
                >
                  Create Member
                </button>
              </div>
            </div>

            <div className="overflow-x-auto rounded-md border dark:border-[#c4c4c432]">
              <table className="w-full text-sm text-left overflow-hidden">
                <thead className="bg-white dark:bg-slate-800 px-3 md:px-4 border text-gray-400 dark:border-[#c4c4c432] border-b text-sm font-semibold">
                  <tr>
                    <th scope="col" className="px-6 py-4 whitespace-nowrap w-5">
                      #
                    </th>
                    <th scope="col" className="px-6 py-4 whitespace-nowrap max-w-52">
                      Member name
                    </th>
                    <th scope="col" className="px-6 py-4 whitespace-nowrap">
                      IP Address
                    </th>
                    <th scope="col" className="px-6 py-4 whitespace-nowrap">
                      Port
                    </th>
                    <th scope="col" className="px-6 py-4 whitespace-nowrap">
                      Weight
                    </th>
                    <th scope="col" className="px-6 py-4 whitespace-nowrap">
                      Backup
                    </th>
                    <th scope="col" className="px-6 py-4 whitespace-nowrap">
                      Operating Status
                    </th>
                    <th scope="col" className="px-6 py-4 whitespace-nowrap">
                      Provisioning Status
                    </th>
                    <th scope="col" className="px-6 py-4 whitespace-nowrap">
                      Admin State
                    </th>
                    <th scope="col" className="px-6 py-4 whitespace-nowrap">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white dark:bg-slate-800 px-3 md:px-4 border rounded-b-md dark:border-[#c4c4c432] border-t-2 text-sm">
                  {currentEntries.map((row, index) => (
                    <tr
                      key={index}
                      className="dark:hover:bg-[#ffffff05] hover:bg-brandBlue/25 whitespace-nowrap"
                    >
                      <td className="text-start py-4 px-6">{index + 1}.</td>
                      <td
                        className="text-start py-4 px-6 text-primaryBlue hover:underline cursor-pointer"
                        onClick={() =>
                          showMemberDetailsModal(memberList.find((s) => s.id === row.id))
                        }
                      >
                        {row.name}
                      </td>
                      <td className="text-start py-4 px-6">{row.ipAddress}</td>
                      <td className="text-start py-4 px-6">{row.port}</td>
                      <td className="text-start py-4 px-6">{row.weight}</td>
                      <td className="text-start py-4 px-6">{row.backup}</td>
                      <td className="text-start py-4 px-6">{row.operatingStatus}</td>
                      <td className="text-start py-4 px-6">{row.provisioningStatus}</td>
                      <td className="text-start py-4 px-6">{row.adminState}</td>
                      <td className="text-start py-4 px-6">
                        <button
                          className="text-white p-3 text-xs rounded bg-primaryBlue w-full md:w-fit"
                          onClick={() => showManageMonitorModal(index, row)}
                        >
                          Manage Member
                        </button>

                        {manageHealthMonitorModal === index && (
                          <div className="w-full fixed h-screen bg-black/70 top-0 left-0 px-4 flex items-end md:items-center justify-center z-50">
                            <div className="bg-white dark:bg-[#141D26] rounded w-full md:w-[30%] dark:text-white max-h-[80%] mb-4 md:mb-0 overflow-auto">
                              <div className="flex justify-between items-center text-sm p-6 border-b dark:border-b-[#c4c4c432]">
                                <div className="flex gap-2 items-center">
                                  <span className="dark:text-white">Manage "{row.name}"</span>
                                </div>
                                <img
                                  src={close}
                                  onClick={closeManageSubnetModal}
                                  className="h-5 cursor-pointer"
                                  alt=""
                                />
                              </div>
                              <div className="p-4 grid gap-1">
                                <div
                                  className="flex items-center justify-between hover:rounded mb-4 dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all cursor-pointer"
                                  onClick={() => toggleEditMemberModal()}
                                >
                                  <span>Edit Member</span>
                                  <span>
                                    <img src={arrow} alt="" className="" />
                                  </span>
                                </div>

                                <div
                                  className="flex justify-self-center text-red-500 rounded-md py-5 px-3 text-center cursor-pointer"
                                  onClick={() => {
                                    setDeleteMemberModal(true);
                                  }}
                                >
                                  <span className="hover:underline">Delete Member</span>
                                </div>
                              </div>
                              <Modal
                                title={"Delete Member"}
                                isVisible={deleteMemberModal}
                                onClose={() => setDeleteMemberModal(false)}
                              >
                                <div className="text-sm text-center pt-6 text-wrap">
                                  Are you sure you want to delete{" "}
                                  <span className="underline">{row.name}</span>. This action
                                  cannot be undone.
                                </div>
                                <div className="grid gap-4 justify-center py-6">
                                  <button
                                    className="bg-red-500 text-white text-xs px-6 py-4 rounded-sm w-fit"
                                    onClick={() => deleteLoadPoolMember(row.id)}
                                  >
                                    Yes, delete {row.name}
                                  </button>
                                  <button
                                    className="text-[#1DA1F2] text-sm px-6 py-2 hover:underline"
                                    onClick={() => setDeleteMemberModal(false)}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </Modal>
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="grid justify-center gap-4 md:flex md:justify-between items-center mt-4">
              <p className="text-gray-400 text-sm">
                Showing{" "}
                <span className="font-medium text-black dark:text-white">
                  {indexOfFirstEntry + 1}
                </span>{" "}
                to{" "}
                <span className="font-medium text-black dark:text-white">
                  {Math.min(indexOfLastEntry, memberListMap?.length)}
                </span>{" "}
                of{" "}
                <span className="font-medium text-black dark:text-white">
                  {memberListMap?.length}
                </span>{" "}
                results
              </p>
              <div className="flex gap-3">
                <button
                  className={`bg-white dark:bg-primaryBlue border dark:border-none rounded-md py-3 px-5 text-sm ${
                    currentPage === 1 ? "opacity-50" : "opacity-100"
                  }`}
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <button
                  className={`bg-white dark:bg-primaryBlue border dark:border-none rounded-md py-3 px-5 text-sm ${
                    currentPage === totalPages ? "opacity-50" : "opacity-100"
                  }`}
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="md:px-52 text-center grid text-gray-500 mt-32">
              <div>
                It looks like you don't have members attached to this pool yet. Once you
                create a pool, your members will appear here.
              </div>
              <div className="w-full flex flex-col items-center justify-center mt-4">
                <button
                  className={`cursor-pointer px-4 py-3 text-xs border-[1.5px] border-primaryBlue rounded-md text-primaryBlue w-fit`}
                  onClick={toggleCreateMemberModal}
                >
                  Create Member
                </button>
              </div>
            </div>
          </>
        )}
      </div>

      {healthMonitorDetailsModal && selectedMember && (
        <div className="fixed w-full bg-black/60 top-0 left-0 z-50 h-screen">
          <div className="w-full flex h-full items-center justify-center p-4">
            <div className="bg-white dark:bg-[#141D26] dark:text-white w-full md:w-[80%] rounded h-full overflow-y-auto">
              <div className="px-6 md:px-10 py-6 border-b dark:border-b-[#c4c4c432] flex justify-between items-center">
                <span className="text-primaryBlue font-medium">Member Information:</span>
                <span onClick={closeHealthMonitorDetailsModal} className="cursor-pointer">
                  <img src={close} alt="Close" className="h-5" />
                </span>
              </div>

              <div className="py-10 grid gap-6 px-6">
                <div className="w-full flex flex-col items-start gap-4">
                  <h4 className="w-full text-black dark:text-white text-lg mb-4 border-b border-gray-400 pb-2">
                    Member Details:
                  </h4>

                  <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6">
                    {memberOverviewDetails.map((detail, index) => (
                      <div key={index} className="w-full flex flex-col items-start">
                        <h4 className="text-black dark:text-white text-lg">{detail.title}:</h4>
                        <h4 className="text-gray-800 dark:text-gray-200 font-semibold text-xl">
                          {detail.value}
                        </h4>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {createMemberModal && (
        <div className="fixed top-0 h-screen w-full left-0 z-50 flex items-center justify-center p-4 bg-[rgba(0,0,0,0.5)]">
          <div className="bg-white dark:bg-[#141D26] rounded-md p-4 md:p-10 w-full md:w-[80%] max-h-[95%] overflow-y-scroll shadow-xl shadow-[rgba(0,0,0,0.5)]">
            <div className="flex items-center justify-between mb-4">
              <p className="text-primaryBlue">Create Members</p>
              <span onClick={toggleCreateMemberModal} className="cursor-pointer">
                <img alt="" src={close} className="h-5" />
              </span>
            </div>
            <div className="mb-6 p-4 bg-blue-100 dark:bg-blue-900 rounded-md">
              <p className="text-gray-800 dark:text-gray-200 text-sm">
                <span className="font-semibold">Pricing:</span> Each pool member/node costs{" "}
                {currency === "NGN" ? (
                  <>
                    <span className="font-bold">₦6,000</span>
                  </>
                ) : (
                  <>
                    <span className="font-bold">$4</span> per month.
                  </>
                )}
              </p>
              <p className="text-gray-800 dark:text-gray-200 text-sm mt-2">
                You are adding{" "}
                <span className="font-bold">{createMemberForm.values.members.length}</span>{" "}
                member(s). Estimated monthly cost:{" "}
                {currency === "NGN" ? (
                  <>
                    <span className="font-bold">
                      ₦{createMemberForm.values.members.length * 6000}
                    </span>
                  </>
                ) : (
                  <>
                    <span className="font-bold">
                      ${createMemberForm.values.members.length * 4}
                    </span>
                  </>
                )}
              </p>
            </div>
            <form onSubmit={createMemberForm.handleSubmit}>
              {createMemberInputs.map((memberGroup, index) => (
                <div
                  key={index}
                  className="mb-6 border-b pb-4"
                >
                  <h4 className="text-gray-800 dark:text-gray-200 text-lg font-semibold mb-4">
                    {memberGroup.title}
                  </h4>
                  <TabContent title="" inputs={memberGroup.inputs} />
                  <button
                    type="button"
                    className="text-red-500 text-sm mt-2"
                    onClick={() => removeMember(index)}
                    disabled={createMemberForm.values.members.length === 1}
                  >
                    Remove
                  </button>
                </div>
              ))}
              <button
                type="button"
                className="py-2 px-4 rounded-md text-sm border border-primaryBlue text-primaryBlue cursor-pointer mb-6"
                onClick={addMember}
              >
                Add Member
              </button>

              <LoadBalancerInstances/>
              <div className="w-full flex flex-col justify-end items-end mt-6 pt-6 border-t border-t-gray-200">
                <Button
                  buttonText="Create Members"
                  buttonRole="submit"
                  type="submit"
                  handleClick={createMemberForm.handleSubmit}
                />
              </div>
            </form>
          </div>
        </div>
      )}

      {editMemberModal && (
        <div className="fixed top-0 h-screen w-full left-0 z-50 flex items-center justify-center p-4 bg-[rgba(0,0,0,0.5)]">
          <div className="bg-white dark:bg-[#141D26] rounded-md p-4 md:p-10 w-full md:w-[60%] max-h-[80%] overflow-y-scroll shadow-xl shadow-[rgba(0,0,0,0.5)]">
            <div className="flex items-center justify-between mb-4">
              <p className="text-primaryBlue">Update Member for {selectedMember?.name}</p>
              <span onClick={toggleEditMemberModal} className="cursor-pointer">
                <img alt="" src={close} className="h-5" />
              </span>
            </div>
            <TabContent title="" inputs={editMemberInputs} />
            <div className="w-full flex flex-col justify-end items-end mt-6 pt-6 border-t border-t-gray-200">
              <Button
                buttonText="Update Member"
                buttonRole="submit"
                type="submit"
                handleClick={editMemberForm.handleSubmit}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoadBalancerMembers;

